// extracted by mini-css-extract-plugin
export default {"upstreamContainer":"scopeUpstreamList_upstreamContainer__LYQYd","loaderAnimation":"scopeUpstreamList_loaderAnimation__KQauA"};